<template>
    <div class="content-wrapper">
        <div class="container-lg">
            <div class="row">
                <app-navbar/>
            </div>
            <div class="row mb-12">
                <div class="col">
                    <!-- <div class="row">
                        <div class="col">
                            <div class="content-card">
                                <div class="content-card-title">
                                    <div class="row">
                                        <div class="col"><i class="fas fa-calendar-alt"></i> วันที่ เริ่ม-สิ้นสุด</div>
                                    </div>

                                </div>
                                <div class="content-card-body">
                                    <div class="row">
                                        <b-col cols="12" md=4 style="padding-bottom:5px" @click="gamesHistory()">
                                            <b-form-datepicker v-model="date_from" id="datepicker-from"
                                                :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                                                locale="th" placeholder="จากวันที่" size="sm"></b-form-datepicker>
                                        </b-col>
                                        <b-col cols="12" md=4 style="padding-bottom:5px" @click="gamesHistory()">
                                            <b-form-datepicker v-model="date_to" id="datepicker-to"
                                                :date-format-options="{ year: 'numeric', month: 'short', day: '2-digit', weekday: 'short' }"
                                                locale="th" placeholder="ถึงวันที่" size="sm"></b-form-datepicker>
                                        </b-col>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br> -->
                    <div class="row">
                        <div class="col">
                            <div class="content-card mb-4">
                                <div class="content-card-title">
                                    <div class="row">
                                        <div class="col">รายการ</div>
                                    </div>

                                </div>

                                <div class="content-card-body p-0">

                                    <div class="table-responsive text-nowrap">
                                        <table
                                            class="table table-sm table-hover table-bordered table-striped table-vcenter">
                                            <thead class="thead-light">
                                                <tr class="text-center">
                                                    <th scope="col">ค่ายเกม</th>
                                                    <th scope="col">เงินเดิมพัน</th>
                                                    <th scope="col">ชนะ</th>
                                                    <th scope="col">เพิ่มเติม</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="" id="" v-for="(item, id) in gamesHistoryData" :key="id">
                                                    <td class="td-center">{{ item.agentGame }}</td>
                                                    <td class="td-right">{{ numberWithCommas(item.betamount) }}</td>
                                                    <td v-if="item.winamount > 0" class="text-green td-right">+{{
                                                        numberWithCommas(item.winamount) }}</td>
                                                    <td v-else class="text-red td-right">{{
                                                        numberWithCommas(item.winamount) }}</td>
                                                    <td class="text-center">
                                                        <button v-b-modal="'gameDetailModal_' + item.agentGame" href="gamehistory" class="btn btn-warning btn-xs "><i
                                                            class=" fa-regular fa-eye"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="push">
                <div v-for="(item, id) in gamesHistoryData" :key="id">
                    <b-modal style="height: 100%;"
                        v-bind="{ id: 'gameDetailModal_' + item.agentGame, title: 'ค่ายเกม : ' + item.agentGame }"
                        scrollable hide-footer size="xl">
                        <table class="table table-sm table-hover table-bordered table-striped table-vcenter">
                            <thead class="thead-light">
                                <tr class="text-center">
                                    <th scope="col">รูป</th>
                                    <th scope="col">ชื่อเกม</th>
                                    <th scope="col">เงินเดิมพัน</th>
                                    <th scope="col">Valid Amount</th>
                                    <th scope="col">ผลชนะ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="" id="" v-for="(data, id) in item.item" :key="id">
                                    <td class="td-center">
                                        <b-img class="w-100" v-bind="{ src: data.item_image }" fluid
                                            alt="Responsive image" style="max-width: 4rem;"></b-img>
                                    </td>
                                    <td class="td-center">{{ data.item_games_name }}</td>
                                    <td class="td-center">{{ data.item_betAmount }}</td>
                                    <td class="td-center">{{ data.item_validAmount }}</td>
                                    <td v-if="data.item_winAmount > 0" class="text-green td-right">+{{
                                        numberWithCommas(data.item_winAmount) }}</td>
                                    <td v-else class="text-red td-right">{{ numberWithCommas(data.item_winAmount) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <b-button class="mt-3" variant="primary" size="sm" block
                            @click="$bvModal.hide('gameDetailModal_' + item.agentGame)">ปิด</b-button>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import navbar from '@/components/sakha/game/navbar'
import { mapActions, mapGetters } from 'vuex'
import * as numeral from 'numeral'
export default {
  components: {
    'app-navbar': navbar
  },
  async mounted () {
    if (process.env.VUE_APP_CASINO_ENABLE.toLowerCase().trim() === 'false') {
      this.$router.push('/home')
    }
    try {
      const today = new Date()
      this.date_from = (today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate())
      this.date_to = (today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate())
      await this.gamesHistory()
    } catch (error) {
    }
  },
  computed: {
    ...mapGetters([
      'getGames'
    ])
  },
  methods: {
    ...mapActions(['getGamesHistory']),
    numberWithCommas (x) {
      return numeral(x).format('0,0.00')
    },
    async gamesHistory () {
      console.log('gamesHistory')
      const resp = await this.getGamesHistory({
        date: {
          from: this.date_from,
          to: this.date_to
        }
      })
      // const today = new Date()
      // console.log('resp.status_code:' + resp.KINGMAKER)
      this.gamesHistoryData = resp
      // console.log('resp:' + resp)
      // console.log('today:' + (today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()))
    }
  },
  data () {
    return {
      date_from: '',
      date_to: '',
      gamesHistoryData: []
    }
  }
}
</script>
<style>
.modal {
    display: block !important;
}
</style>
